(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setButtonLabel(button, label) {
      if (!button) return;
      const node = Array.from(button.childNodes).find(function (item) {
        return item.nodeType === Node.TEXT_NODE && item.textContent.trim();
      });
      if (node) node.textContent = label;
    }

    function bindZoom(stage, img) {
      if (!stage || !img || stage.dataset.cfZoom != null) return;
      stage.dataset.cfZoom = '';
      const SCALE = 2.2;
      const HOLD_MS = 250;
      const MOVE_TOLERANCE = 10;
      let rect = null;
      let holdTimer = null;
      let startPoint = null;
      let touchZoom = false;

      stage.style.setProperty('--cf-zoom', String(SCALE));

      function isControl(target) {
        return target && target.closest && target.closest('button, a, [data-cf-gallery-prev], [data-cf-gallery-next]');
      }

      function aim(x, y) {
        if (!rect) rect = img.getBoundingClientRect();
        const px = Math.min(100, Math.max(0, ((x - rect.left) / rect.width) * 100));
        const py = Math.min(100, Math.max(0, ((y - rect.top) / rect.height) * 100));
        img.style.transformOrigin = px + '% ' + py + '%';
      }

      function start(x, y) {
        img.style.transform = '';
        rect = img.getBoundingClientRect();
        aim(x, y);
        stage.classList.add('is-zooming');
      }

      function stop() {
        clearTimeout(holdTimer);
        holdTimer = null;
        startPoint = null;
        touchZoom = false;
        rect = null;
        stage.classList.remove('is-zooming');
      }

      // Mouse: hover zooms, moving pans, leaving resets.
      stage.addEventListener('pointermove', function (event) {
        if (event.pointerType !== 'mouse') return;
        if (isControl(event.target)) {
          if (stage.classList.contains('is-zooming')) stop();
          return;
        }
        if (!stage.classList.contains('is-zooming')) start(event.clientX, event.clientY);
        else aim(event.clientX, event.clientY);
      });
      stage.addEventListener('pointerleave', function (event) {
        if (event.pointerType === 'mouse') stop();
      });

      // Touch: hold about 250ms to zoom, then move to pan; lift to reset.
      // A quick swipe never reaches the hold time, so it still changes slide.
      stage.addEventListener('touchstart', function (event) {
        stage.dataset.cfZoomUsed = 'false';
        if (event.touches.length !== 1 || isControl(event.target)) {
          stop();
          return;
        }
        const touch = event.touches[0];
        startPoint = { x: touch.clientX, y: touch.clientY };
        clearTimeout(holdTimer);
        holdTimer = setTimeout(function () {
          holdTimer = null;
          if (!startPoint) return;
          touchZoom = true;
          stage.dataset.cfZoomUsed = 'true';
          start(startPoint.x, startPoint.y);
        }, HOLD_MS);
      }, { passive: true });

      stage.addEventListener('touchmove', function (event) {
        const touch = event.touches[0];
        if (!touch) return;
        if (touchZoom) {
          event.preventDefault();
          aim(touch.clientX, touch.clientY);
          return;
        }
        if (startPoint && (Math.abs(touch.clientX - startPoint.x) > MOVE_TOLERANCE || Math.abs(touch.clientY - startPoint.y) > MOVE_TOLERANCE)) {
          clearTimeout(holdTimer);
          holdTimer = null;
          startPoint = null;
        }
      }, { passive: false });

      stage.addEventListener('touchend', stop);
      stage.addEventListener('touchcancel', stop);
      stage.addEventListener('contextmenu', function (event) {
        if (touchZoom || holdTimer) event.preventDefault();
      });
      window.addEventListener('scroll', function () {
        if (!touchZoom && holdTimer) {
          clearTimeout(holdTimer);
          holdTimer = null;
          startPoint = null;
        }
      }, { passive: true });
    }

    function bindGallery(root) {
      const gallery = root.querySelector('[data-cf-gallery]') || root.querySelector('.cf-gallery');
      if (gallery && gallery.dataset.cfGalleryBound === 'true') {
        return {
          showMedia: function () {},
        };
      }
      if (gallery) gallery.dataset.cfGalleryBound = 'true';
      const main = root.querySelector('[data-cf-main]');
      const thumbs = Array.from(root.querySelectorAll('[data-cf-thumb]'));
      const prev = root.querySelector('[data-cf-gallery-prev]');
      const next = root.querySelector('[data-cf-gallery-next]');
      const stage = root.querySelector('[data-cf-gallery-stage]');

      function showIndex(index) {
        if (!main || !thumbs.length) return;
        const count = thumbs.length;
        const nextIndex = ((index % count) + count) % count;
        const thumb = thumbs[nextIndex];
        thumbs.forEach(function (item) {
          const selected = item === thumb;
          item.classList.toggle('is-active', selected);
          if (selected) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        if (stage) stage.classList.remove('is-zooming');
        if (thumb.dataset.full) main.src = thumb.dataset.full;
        main.srcset = thumb.dataset.srcset || '';
        if (thumb.dataset.alt) main.alt = thumb.dataset.alt;
      }

      function currentIndex() {
        const active = thumbs.findIndex(function (item) {
          return item.classList.contains('is-active');
        });
        return active < 0 ? 0 : active;
      }

      function showMedia(mediaId) {
        if (mediaId == null || mediaId === '') return;
        const index = thumbs.findIndex(function (item) {
          return item.dataset.mediaId === String(mediaId);
        });
        if (index < 0) return;
        showIndex(index);
      }

      bindZoom(stage, main);

      if (thumbs.length < 2) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return { showMedia: showMedia };
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          showIndex(index);
        });
      });
      if (prev) {
        prev.addEventListener('click', function () {
          showIndex(currentIndex() - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          showIndex(currentIndex() + 1);
        });
      }
      if (stage) {
        let startX = null;
        stage.addEventListener('touchstart', function (event) {
          if (event.target.closest('[data-cf-gallery-prev], [data-cf-gallery-next]')) return;
          startX = event.touches[0].clientX;
        }, { passive: true });
        stage.addEventListener('touchend', function (event) {
          if (startX == null) return;
          if (stage.dataset.cfZoomUsed === 'true') {
            startX = null;
            return;
          }
          const delta = event.changedTouches[0].clientX - startX;
          startX = null;
          if (Math.abs(delta) > 40) showIndex(currentIndex() + (delta < 0 ? 1 : -1));
        });
      }

      return { showMedia: showMedia };
    }

    function init(root) {
      if (root.dataset.cfReady === 'true') return;
      root.dataset.cfReady = 'true';
      const gallery = bindGallery(root);
      const dataEl = root.querySelector('[data-cf-variants]');
      if (!dataEl) return;
      let variants = [];
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }

      const select = root.querySelector('[data-cf-variant]');
      const price = root.querySelector('[data-cf-price]');
      const compare = root.querySelector('[data-cf-compare]');
      const sku = root.querySelector('[data-cf-sku]');
      const skuValue = root.querySelector('[data-cf-sku-value]');
      const stock = root.querySelector('[data-cf-stock]');
      const button = root.querySelector('[ref="addToCartButton"]');

      function plainMoney(value) {
        const holder = document.createElement('span');
        holder.innerHTML = value || '';
        return (holder.textContent || '').replace(/\s+/g, ' ').trim();
      }

      function apply(id) {
        const variant = variants.find(function (item) {
          return String(item.id) === String(id);
        });
        if (!variant) return;
        if (price) {
          price.textContent = plainMoney(variant.price);
          if (variant.priceCents != null) price.dataset.cfPriceCents = String(variant.priceCents);
          root.dispatchEvent(new CustomEvent('cf:variant'));
        }
        if (compare) {
          compare.hidden = !variant.compare;
          compare.textContent = plainMoney(variant.compare);
        }
        if (sku && skuValue) {
          sku.hidden = !variant.sku;
          skuValue.textContent = variant.sku || '';
        }
        if (stock) {
          stock.textContent = variant.available ? root.dataset.labelStock : root.dataset.labelSold;
          stock.classList.toggle('is-out', !variant.available);
        }
        if (button) {
          button.disabled = !variant.available;
          setButtonLabel(button, variant.available ? root.dataset.labelAdd : root.dataset.labelSold);
        }
        gallery.showMedia(variant.mediaId);
        if (window.history && window.history.replaceState) {
          const next = new URL(window.location.href);
          next.searchParams.set('variant', String(id));
          window.history.replaceState({}, '', next);
        }
      }

      if (select && select.tagName === 'SELECT') {
        select.addEventListener('change', function () {
          apply(select.value);
        });
      }

    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-cf-product]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scan();
      });
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function load(root) {
      if (!root || root.dataset.cfLoaded === 'true' || !root.dataset.url) return;
      root.dataset.cfLoaded = 'true';
      fetch(root.dataset.url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const next = doc.querySelector('[data-cf-related]');
          if (!next || next.querySelector('[data-cf-empty]')) {
            root.hidden = true;
            return;
          }
          root.innerHTML = next.innerHTML;
          root.hidden = false;
        })
        .catch(function () {
          root.hidden = true;
        });
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-cf-related]').forEach(load);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scan();
      });
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-specs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function tabsIn(root) {
      return Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    }

    function select(root, tab) {
      if (!tab) return;
      tabsIn(root).forEach(function (item) {
        var on = item === tab;
        item.setAttribute('aria-selected', on ? 'true' : 'false');
        item.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(item.getAttribute('aria-controls'));
        if (!panel) return;
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    }

    function bind(root) {
      if (root.dataset.cfTabsBound === 'true') return;
      root.dataset.cfTabsBound = 'true';
      var tabs = tabsIn(root);
      if (!tabs.length) return;
      var selected = tabs.filter(function (tab) {
        return tab.getAttribute('aria-selected') === 'true';
      });
      if (selected.length !== 1) select(root, tabs[0]);

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          select(root, tab);
        });
        tab.addEventListener('keydown', function (event) {
          var key = event.key;
          var next = null;
          if (key === 'ArrowRight' || key === 'ArrowDown') {
            next = tabs[(index + 1) % tabs.length];
          } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
            next = tabs[(index - 1 + tabs.length) % tabs.length];
          } else if (key === 'Home') {
            next = tabs[0];
          } else if (key === 'End') {
            next = tabs[tabs.length - 1];
          }
          if (!next || next === tab) return;
          event.preventDefault();
          select(root, next);
          next.focus();
          if (next.scrollIntoView) {
            next.scrollIntoView({ inline: 'nearest', block: 'nearest' });
          }
        });
      });
    }

    function applyOverviewDescription(scope) {
      (scope || document).querySelectorAll('[data-cf-overview-plain]').forEach(function (node) {
        if (node.dataset.cfOverviewApplied === 'true') return;
        var description = '';
        try {
          description = JSON.parse(node.textContent);
        } catch (error) {
          return;
        }
        if (typeof description !== 'string') return;
        description = description.replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
        if (!description) return;
        var changedAny = false;
        document.querySelectorAll('script[type="application/ld+json"]').forEach(function (script) {
          if (script.hasAttribute('data-cf-faq-json')) return;
          var data;
          try {
            data = JSON.parse(script.textContent);
          } catch (error) {
            return;
          }
          var changed = false;
          function visit(value) {
            if (!value || typeof value !== 'object') return;
            if (Array.isArray(value)) {
              value.forEach(visit);
              return;
            }
            var type = value['@type'];
            var types = Array.isArray(type) ? type : [type];
            if (types.indexOf('Product') !== -1) {
              value.description = description;
              changed = true;
            }
            Object.keys(value).forEach(function (key) {
              if (key === 'description') return;
              var child = value[key];
              if (child && typeof child === 'object') visit(child);
            });
          }
          visit(data);
          if (changed) {
            script.textContent = JSON.stringify(data);
            changedAny = true;
          }
        });
        if (changedAny) node.dataset.cfOverviewApplied = 'true';
      });
    }

    function scan(scope) {
      applyOverviewDescription(scope);
      (scope || document).querySelectorAll('[data-cf-spec-tabs]').forEach(bind);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
    else scan();
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
    document.addEventListener('shopify:block:select', function (event) {
      var panel = event.target && event.target.closest ? event.target.closest('[role="tabpanel"]') : null;
      if (!panel) return;
      var root = panel.closest('[data-cf-spec-tabs]');
      if (!root) return;
      var tab = document.getElementById(panel.getAttribute('aria-labelledby'));
      if (!tab) return;
      select(root, tab);
      tab.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
